import React, { useState, useRef, useEffect, useContext } from "react";
import { ContextApi } from "../../../App";
import { v4 as uuidv4 } from "uuid";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { STATE_AND_CITIES } from "../../../utils/StateAndCities";
import { Select, Skeleton, Space } from "antd";

const { Option } = Select;

function StateCity({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "statecity",
    properties: {
      required: true,
      placeholder: "Enter here...",
      label: "State And City",
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
  });

  const [modal, setModal] = useState(false);
  const contextData = useContext(ContextApi);
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementRequiredRef = useRef();
  const toggle = () => setModal(!modal);

  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      //   previousState.disableField = disableFieldRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit: !contextData.contextData.isEdit,
    });
  }
  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e, element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <div className="form-group">
        <div className="mb-3">
          <label htmlFor="">
            Select State
            {element.properties.required && (
              <span style={{ color: "red" }}>*</span>
            )}
          </label>
          <Select
            id="state"
            showSearch
            style={{ width: "100%", height: "37px" }}
            placeholder="Select State"
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            <Option value={""}>Select State</Option>
          </Select>
        </div>
        <div className="mb-3">
          <label htmlFor="candidate photo">
            Select City
            <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            id="city"
            showSearch
            style={{ width: "100%", height: "37px" }}
            placeholder="Select City"
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            <Option value={""}>Select City</Option>
          </Select>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit State City Properties</ModalHeader>
        <ModalBody>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          {/* <div className="custom-control custom-checkbox">
          <input
            ref={disableFieldRef}
            type="checkbox"
            className="custom-control-input"
            id="disableField"
            defaultChecked={element.disableField}
          />
          <label className="custom-control-label" htmlFor="disableField">
            Disable preFilled Field(only admin can edit)
          </label>
        </div> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default StateCity;
